<template>

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
              
                           
                            <form @submit.prevent="save" v-if="entity">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="col-form-label" for="descrizione">Descrizione</label>
                                            <input type="text" class="form-control required" id="descrizione" name="descrizione" placeholder="Descrizione tipologia" v-model="entity.description">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <label class="col-form-label" for="descrizione">Colore</label>
                                        <div class="mb-3">
                                            <span class="p-1 pr-2 pl-2 border rounded-lg" :style="entity.backgroundColor|tagtypecss">tag di esempio</span>
                                        </div>
                                        <chrome-picker :disableAlpha="true" v-model="colors" @input="updateFromPicker"></chrome-picker>
                                    </div>
                                    <div class="col-6">
                                        <label class="col-form-label" for="descrizione">&nbsp;</label>
                                        
                                    </div>
                                   
                                </div>




                                <div class="form-group mt-3">
                                    <button type="button" class="btn btn-xs  btn-primary m-1" v-on:click="save">Salva  <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>
                                    <button type="button" class="btn btn-xs  btn-danger m-1" v-on:click="cancel">Annulla  <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon></button>
                                </div>
                            </form>
                        
                </div>
            </div>
        </div>
       

    </div>


</template>

<script>
    import Editor from '@tinymce/tinymce-vue'
    import axios from 'axios'
    import { Chrome } from 'vue-color';
    import { Slider } from 'vue-color';
    export default {
        data() {
            return {
                entity: null,
                colors: '#FFFFFF'
            };
        },
        computed: {
           
            tinyKey: function () {
                return window.SETTINGS.TinyApiKey;
            }
        },
        components: {
            Editor,
             'chrome-picker': Chrome
        },
        name: 'TagTypeSave',
        beforeMount() {
            var me = this;
          
           
            axios.get("tag/type/" + me.$route.params.id).then(response => {
               
              
                me.colors = response.data.backgroundColor || '#FFFFFF';
                me.entity = response.data;
                me.entity.backgroundColor = me.entity.backgroundColor || '#FFFFFF'
                 if(me.entity.description && me.entity.description!=''){
 me.$store.state.breadCrump.title = me.entity.description;

                                }
            })



        },
        methods: {
            cancel() {
                this.$router.push({
                    name: "route-tagtype-list",

                    replace: true
                });
            },
              updateFromPicker(color) {
                this.entity.backgroundColor = color.hex;
            },
            save() {
                axios.post("tag/type", this.entity).then(response => { console.log(response) })
            }
        }
    };
</script>
